
import { Component, Vue } from 'vue-property-decorator'
import * as modules from '../../store/decorator'

@Component
export default class AgreementCheck extends Vue {
    
    async checkAgreementStatus() {
        // Check if user is authenticated first
        if (!this.$auth.check()) {
            return
        }

        // Use cached agreement data from store instead of making API call
        if (!modules.user.agreementDetail.agreementAccepted) {
            this.$router.push({ name: 'agreement' })
            return
        }
    }
}
